import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import Quiz from './quiz';
import Message from './message';

import thunk from 'redux-thunk';
import {Provider, useDispatch}  from 'react-redux';
import {createStore}  from 'redux';
import {applyMiddleware}  from 'redux';

import {actions}  from './redux_actions';


const initialState = {
	message: 'Тут показываются технические сообщения системы',
	showMessage: false,
	questions: [],
	// userAnswers: [1,1,1,1,1,1,1,1,1],
	userAnswers: [],
	// nowQuestion: 9,
	nowQuestion: 0,
};	


const rootReducer = function(state  = initialState, action) {
	let newState;
	
	switch(action.type) {
		case 'SHOW_MESSAGE':
			return {...state, message: action.payload, showMessage: true};
		case 'HIDE_MESSAGE':
			return {...state, showMessage: false};
		case 'ADD_QUESTIONS':
			return {...state, questions: action.payload};
		case 'SAVE_USER_ANSWER':
			newState = {...state};
			newState.userAnswers[action.payload.questionIndex] = action.payload.userAnswer;
			newState.nowQuestion++;
			return newState;
		default:
			return state;
	}
}

const store = createStore(rootReducer, applyMiddleware(thunk));

function App(props) {
	const dispatch = useDispatch();
	
	useEffect(() => {
		dispatch(actions.showMessage('Запрашиваю с сервера вопросы и ответы для теста...'));
		// console.log('fetch');
		fetch('https://dmitriyzhuravlev.ru/php/frontendquiz/get.php')
		.then((r) => r.json())
		.then((data) => {
			dispatch(actions.showMessage('Получено ' + data.length + ' вопросов.'));
			dispatch(actions.runHidingMessage());
			dispatch(actions.addQuestions(data));
		})
		.catch((e) => {
			dispatch(actions.showMessage('Возникла ошибка! ' + String(e)));
		} );
	});
	
	
	return (
		<>
			<h1>
				Тестирование знаний по фронтенду
			</h1>
			<Message />
			<Quiz/>
		</>
	);
}



ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>
	,
	document.getElementById('root')
);
